import React from 'react';
import { ArrowRight, Smartphone, Play, Code, Database, Shield, Zap, Users, TrendingUp, CheckCircle, Award } from 'lucide-react';
import Header from "./header";
import Footer from './footer';
const CombinedAppServices = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <Header />

      {/* Hero Section - Application Development */}
      <section className="bg-gradient-to-br from-blue-50 via-indigo-50 to-cyan-50 py-20 relative overflow-hidden">
        <div className="absolute top-10 right-10 w-20 h-20 bg-blue-200 rounded-full opacity-50 animate-pulse"></div>
        <div className="absolute bottom-20 left-10 w-16 h-16 bg-indigo-200 rounded-full opacity-60 animate-bounce"></div>
        <div className="absolute top-1/2 right-1/4 w-12 h-12 bg-cyan-200 rounded-full opacity-40 animate-pulse"></div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-flex items-center px-4 py-2 bg-blue-100 rounded-full text-blue-700 text-sm font-medium mb-6">
                <Award className="h-4 w-4 mr-2" />
                Future-ready application solutions
              </div>

              <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
                Application <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600">
                  Development
                </span>

              </h1>

              <p className="text-xl text-gray-600 mb-8 leading-relaxed">
                In today's rapidly evolving digital landscape,enterprises are constantly challenged to adapt and innovate. Often, legacy systems prove to be
                insufficient. To thrive, businesses need agile, customized application development that aligns with their specific requirements and strategic goals.
              </p>


            </div>

            <div className="relative">
              <div className="bg-white rounded-3xl shadow-2xl p-8 transform hover:scale-105 transition-transform duration-300">
                <div className="mb-6">
                  <video
                    className="w-full h-64 rounded-2xl object-cover"
                    autoPlay
                    muted
                    loop
                    src="/Application.mp4"
                  >
                    Your browser does not support the video tag.
                  </video>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Application Development */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="relative">
              <img
                src="./mobile-app1.jpg"
                alt="Mobile-First Development"
                className="w-full h-auto rounded-2xl shadow-lg object-cover"
              />
            </div>
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">
                About Our
                <span className="text-blue-600 block">Application Development</span>
                <span className="text-gray-900">Services</span>
              </h2>
              <p className="text-gray-600 mb-6">
                Technology is changing the way businesses are done
                and this also means that every way of conducting business
                is also changing. With a lot of emerging technologies,
                the ever-changing cloud platforms, the explosion of
                digital platforms, mobile applications, and application
                upgrades, enterprises are looking for customized
                application development services to support their
                business needs.
              </p>
              <p className="text-gray-600 mb-8">
                Anvitech Solutions helps enterprises in
                building custom applications swiftly without
                compromising on quality. Our experts having deep expertise in customizable
                solutions, we help our clients in their transformation
                journey by leveraging our proven and time tested
                deployment tactics and industry best practices.
              </p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="flex items-center">
                  <CheckCircle className="w-5 h-5 text-green-500 mr-2" />
                  <span className="text-gray-700">Agile Development</span>
                </div>
                <div className="flex items-center">
                  <CheckCircle className="w-5 h-5 text-green-500 mr-2" />
                  <span className="text-gray-700">Scalable Architecture</span>
                </div>
                <div className="flex items-center">
                  <CheckCircle className="w-5 h-5 text-green-500 mr-2" />
                  <span className="text-gray-700">Cloud Integration</span>
                </div>
                <div className="flex items-center">
                  <CheckCircle className="w-5 h-5 text-green-500 mr-2" />
                  <span className="text-gray-700">24/7 Support</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Hero Section - Application Maintenance */}
      <section className="bg-gradient-to-br from-cyan-50 to-blue-100 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h1 className="text-5xl font-bold text-gray-900 mb-6">
                Application
                <span className="text-cyan-600 block">Maintenance</span>
              </h1>
              <p className="text-lg text-gray-600 mb-8">
                For enterprises seeking tangible results and a strong
                return on their IT investment, Anvitech Solutions
                offers a focused and value-driven approach to
                application development. By combining deep industry
                expertise with innovative thinking, delivering superior
                end-to-end AMS services that drive real business value and
                support your transformation journey.
              </p>

            </div>
            <div className="relative">
              <img
                src="./maintaince.jpeg"
                alt="Application Maintenance Services"
                className="w-full h-auto rounded-2xl shadow-xl object-cover"
              />
            </div>
          </div>
        </div>
      </section>




      {/* 3E Model Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Anvitech <span className="text-blue-600">3E Model</span>
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              As a IT Software Consulting Services specialist - Anvitech Application Maintenance
              Support (AMS) services are delivered by a proven 3E Managed Services Model – Efficiency,
              Effectiveness, and Experience.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white rounded-xl p-8 shadow-lg">
              <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mb-6">
                <Zap className="w-8 h-8 text-blue-600" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Efficiency</h3>
              <p className="text-gray-600 mb-4">
                Anvitech focuses on reduction in operational costs by continuously improving,
                re-engineering and accelerating operational practices to lay
                foundation for leveraging lean and automation strategies and
                methodologies to achieve improved incident reduction and
                proper root cause analysis for enhanced efficiency.
              </p>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-lg">
              <div className="bg-green-100 w-16 h-16 rounded-full flex items-center justify-center mb-6">
                <TrendingUp className="w-8 h-8 text-green-600" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Effectiveness</h3>
              <p className="text-gray-600 mb-4">
                Anvitech adopts the "OPTIMIZATION" approach to deliver Business Process
                Improvements by orchestrating business and processes across end-to-end
                business workflows through predictive monitoring of business
                performance that helps prevent business disruptions
                and provides root cause analysis on the top-line and bottom-line.
              </p>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-lg">
              <div className="bg-purple-100 w-16 h-16 rounded-full flex items-center justify-center mb-6">
                <Users className="w-8 h-8 text-purple-600" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Experience</h3>
              <p className="text-gray-600 mb-4">
                Anvitech Application Support teams are strategically focused on
                delivering solutions by providing personalized customer experience. This
                is always driven by data and insights which are tailored
                to solve specific business challenges. The focus is on
                continuously engaging with end users and delivering
                business value to ensure potential service
                improvements.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Tigerworld Technologies Difference */}
      {/* <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              <span className="text-blue-600">Anvitech Technologies</span> Difference
            </h2>
            <p className="text-lg text-gray-600 max-w-4xl mx-auto">
              Innovation is at the heart of the Tigerworld Technologies difference. Their significant 
              investment in leading-edge development services clients benefit from proven 
              methodologies and pre-built components, leading to faster deployments and tangible 
              results.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="bg-blue-100 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-4">
                <Code className="w-10 h-10 text-blue-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Very Comprehensive Application Development Services (ADM)</h3>
              <p className="text-gray-600 text-sm">
                We help our clients accelerate a full spectrum of their application development needs, 
                development services which reduce risk and enhance scalability, robust, secure, and easily 
                maintainable.
              </p>
            </div>
            
            <div className="text-center">
              <div className="bg-green-100 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-4">
                <Database className="w-10 h-10 text-green-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Industry Domain Knowledge</h3>
              <p className="text-gray-600 text-sm">
                Tigerworld brings a lot of industry expertise to the table. Our transformational experts are 
                skilled in latest services and deployment techniques which reduce time and cost while 
                offering predictability and comfort.
              </p>
            </div>
            
            <div className="text-center">
              <div className="bg-purple-100 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-4">
                <Shield className="w-10 h-10 text-purple-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Investment Banking Solution Accelerators</h3>
              <p className="text-gray-600 text-sm">
                Tigerworld's innovative approach has been in the space of application development with 
                solutions and this has enabled in helping our clients to budget timelines and proven 
                deployment techniques.
              </p>
            </div>
            
            <div className="text-center">
              <div className="bg-cyan-100 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-4">
                <TrendingUp className="w-10 h-10 text-cyan-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Major Focus on Results with Return on Investment (ROI)</h3>
              <p className="text-gray-600 text-sm">
                Tigerworld's major focus is on delivering application development services and solutions that 
                drive and we give value to our clients to provide end-to-end AMS services to support 
                application development.
              </p>
            </div>
          </div>
        </div>
      </section> */}
      <section className="py-8 bg-gradient-to-br from-blue-600 via-indigo-600 to-purple-700 relative overflow-hidden">
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute top-10 left-10 w-32 h-32 bg-white/10 rounded-full animate-pulse"></div>
          <div className="absolute top-40 right-20 w-24 h-24 bg-white/5 rounded-lg animate-bounce transform rotate-45" style={{ animationDelay: '1s' }}></div>
          <div className="absolute bottom-20 left-20 w-16 h-16 bg-white/10 rounded-full animate-pulse" style={{ animationDelay: '2s' }}></div>
          <div className="absolute bottom-40 right-10 w-20 h-20 bg-white/5 rounded-lg animate-bounce transform -rotate-12" style={{ animationDelay: '0.5s' }}></div>

          <div className="absolute top-1/4 left-1/4 animate-float">
            <Zap className="w-8 h-8 text-white/20" />
          </div>
          <div className="absolute top-1/3 right-1/3 animate-float" style={{ animationDelay: '1.5s' }}>
            <Shield className="w-6 h-6 text-white/20" />
          </div>
          <div className="absolute bottom-1/3 left-1/3 animate-float" style={{ animationDelay: '3s' }}>
            <TrendingUp className="w-7 h-7 text-white/20" />
          </div>
        </div>

        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center">
          {/* Main Content */}
          <div className="space-y-4 animate-fadeInUp">
            <h2 className="text-2xl sm:text-4xl lg:text-4xl font-bold text-white leading-tight animate-slideInLeft">
              Ready to own the experience?
            </h2>
            {/* <p className="text-1xl sm:text-1xl lg:text-1xl text-blue-100">Get started with our comprehensive suite of business solutions today</p> */}
          </div>

          {/* CTA Button - Smaller and More Compact */}
          <div className="mt-6 animate-fadeInUp" style={{ animationDelay: '1.2s' }}>
            <a href='/contact'>
              <button
                className="group relative inline-flex items-center gap-3 bg-gradient-to-r from-white to-blue-50 text-blue-700 px-8 py-3 rounded-xl font-semibold text-lg hover:from-yellow-300 hover:to-orange-300 hover:text-gray-900 transform hover:scale-105 transition-all duration-500 shadow-xl hover:shadow-yellow-300/50"

              >
                <Play className="w-5 h-5 group-hover:animate-bounce" />
                <span>Get In Touch</span>
                <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-300" />

                {/* Button Glow Effect */}
                <div className="absolute inset-0 bg-gradient-to-r from-white/20 to-transparent rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              </button>
            </a>


          </div>
        </div>

        <style jsx>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          33% { transform: translateY(-10px) rotate(5deg); }
          66% { transform: translateY(5px) rotate(-5deg); }
        }
        
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }
        
        @keyframes slideInLeft {
          from { opacity: 0; transform: translateX(-50px); }
          to { opacity: 1; transform: translateX(0); }
        }
        
        @keyframes slideInRight {
          from { opacity: 0; transform: translateX(50px); }
          to { opacity: 1; transform: translateX(0); }
        }
        
        @keyframes slideInUp {
          from { opacity: 0; transform: translateY(40px); }
          to { opacity: 1; transform: translateY(0); }
        }
        
        .animate-float {
          animation: float 4s ease-in-out infinite;
        }
        
        .animate-fadeInUp {
          animation: fadeInUp 0.8s ease-out forwards;
          opacity: 0;
        }
        
        .animate-slideInLeft {
          animation: slideInLeft 0.8s ease-out forwards;
          opacity: 0;
        }
        
        .animate-slideInRight {
          animation: slideInRight 0.8s ease-out forwards;
          opacity: 0;
        }
        
        .animate-slideInUp {
          animation: slideInUp 0.8s ease-out forwards;
          opacity: 0;
        }
      `}</style>
      </section>
      <Footer />
    </div>
  );
};

export default CombinedAppServices;